module.exports = __webpack_public_path__ + "img/IS.75a62d93.svg";